<template>
    <div class="form bid_form">

        <v-modal-contents ref="modal_contents_agree">
            <template v-slot:title>

                <div class="terms_of_use__title mt-30  ">
                    <div class="h2_title">Пользовательское соглашение!</div>

                </div>

            </template>
            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <p class="red">ТЕКСТ НАХОДИТСЯ В РАЗРАБОТКЕ</p>

                    <div class="mt-30">
                        <button class="px-30 btn_bordered "
                                @click="$refs.modal_contents_agree.modal_open()">
                            Прочитал
                        </button>

                    </div>
                </div>
            </template>
        </v-modal-contents>
        <v-modal-contents ref="modal_contents_successfully" class="modal_contents_successfully">
            <template v-slot:title>

                <div class="terms_of_use__title mt-30 pl-3 ">
                    <div class="h2_title">Статус отправки!</div>

                </div>

            </template>
            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <p class="green_messs">Сообщение отправлено!</p>

                </div>
            </template>
        </v-modal-contents>

        <div class="nr_container_content">
            <div class="form__inner">
                <slot name="sm-title"></slot>

                <v-form class="form__content" ref="form_inner"
                        v-model="valid" lazy-validation
                >
                    <div class="form__container">
                        <h2 class="formNew_h2">Напишите нам – и мы подберем оптимальное решение для вашего бизнеса</h2>
                        <div>
                            <div class="form__box">
                                <v-text-field class="form__input"
                                              v-model="name"
                                              :rules="nameRules"

                                >
                                    <template v-slot:label>
                                        ФИО *
                                    </template>
                                </v-text-field>
                            </div>
                            <div class="form__box">

                                <v-text-field class="form__input"
                                              v-model="company"

                                >
                                    <template v-slot:label>
                                        Компания
                                    </template>
                                </v-text-field>
                                <v-text-field class="form__input"
                                              v-model="city"
                                              :rules="cityRules"

                                >
                                    <template v-slot:label>
                                        Город *
                                    </template>
                                </v-text-field>
                            </div>
                            <div class="form__box">
                                <v-text-field class="form__input"
                                              v-model="tel"
                                              :rules="tel_Rules"
                                >
                                    <template v-slot:label>
                                        Телефон
                                    </template>
                                </v-text-field>
                                <v-text-field class="form__input"
                                              v-model="mail"
                                              :rules="mailRules"

                                >
                                    <template v-slot:label>
                                        Электронная почта *
                                    </template>
                                </v-text-field>

                                <v-select
                                        :items="cat_items"
                                        :menu-props="{ contentClass: 'wrapper_cat_items' }"
                                        item-value="sel_id"
                                        v-if="show == 1"
                                        v-model="defaultСatSelected.sel_id"
                                        label="Категория товара *"
                                        class="cat_items align-items-center d-flex"
                                        append-icon="mdi mdi-chevron-down"
                                        :rules="cat_itemsRules"

                                >
                                    <template slot="selection" slot-scope="data">
                                        <span>{{ data.item.name }}</span>
                                    </template>

                                    <template slot="item" slot-scope="data">
                                        <span>{{ data.item.name }}</span>
                                    </template>
                                </v-select>

                            </div>
                            <div class="form__box">
                                <v-textarea class="form__input"
                                            v-model="message"
                                            rows="2"
                                            no-resize
                                >
                                    <template v-slot:label>
                                        Обращение
                                    </template>
                                </v-textarea>
                            </div>
                            <div class="col-12 col-md-12ы">
                                <!-- SmartCaptcha -->
                                <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                                     class="w-100 mt-30"></div>
                                <div class="formNew_wrap__item  mt-30">
                                    <v-checkbox
                                            v-model="checkbox"
                                            :rules="[(v) => !!v || 'Это обязательный пункт']"
                                            required
                                            color="red"
                                    >
                                        <template v-slot:label>
                                            <div class="customLabelForm">
                                                Я выражаю согласие с <a href="javascript:void(0);" target="_blank"
                                                                        @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями
                                                использования</a> моих персональных данных для обработки данного
                                                обращения
                                              ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю согласие с
                                                <a :href="policy" @click="linkOpen(policy)"
                                                   class="position-relative zi-1">
                                                    Политикой конфиденциальности</a> и
                                                <a :href="agreement"
                                                   @click="linkOpen(agreement)"
                                                   class="position-relative zi-1">
                                                    Пользовательским соглашением.
                                                </a>
                                            </div>
                                        </template>
                                    </v-checkbox>

                                    <v-checkbox
                                            v-model="consentToInform"
                                            color="red"
                                            class="mt-0"
                                    >
                                        <template v-slot:label>
                                            <div class="customLabelForm">
                                                Я выражаю согласие на информирование меня о продуктах, акциях, выгодных
                                                предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и
                                                партнеров.
                                            </div>
                                        </template>
                                    </v-checkbox>

                                    <div class="btn_form d-flex align-items-center  ">
                                        <v-btn :disabled="!valid" class="btn-red w-mc"
                                               @click="send_form">
                                            Отправить
                                        </v-btn>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>

                </v-form>
            </div>
        </div>
    </div>
</template>

<script>
import VModalContents from "./modal_contents";
import {mask} from 'vue-the-mask';

export default {
    name: "bidForm",
    props: {
        categories: Array | String | Number | Boolean | Object,
        show: String | Number | Boolean,
        policy: String | Boolean,
        agreement: String | Boolean,
        terms: String | Boolean,
    },
    components: {
        VModalContents: VModalContents,
    },
    directives: {mask},
    data() {
        return {
            captchaPassed: false,
            checkbox: false,
            consentToInform: false,
            valid: true,
            name: '',
            nameRules: [
                (v) => !!v || "Обязательное поле",
                (v) => (v && v.length >= 3) || "Поле 'Имя' не можети быть меньше 3 символов",
            ],
            company: '',
            city: '',
            cityRules: [
                (v) => !!v || "Обязательное поле",
                (v) => (v && v.length >= 3) || "Поле 'Город' не можети быть меньше 3 символов",
            ],
            tel: '',
            tel_Rules: [
                // (v) => /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(v) || "Телефон заполнен неправильно",
            ],
            mail: '',
            mailRules: [
                (v) => !!v || "Обязательное поле",
                (v) => /.+@.+\..+/.test(v) || "Электронная почта заполнена неправильно",
            ],
            message: '',

            cat_itemsRules: [
                (v) => (v && v.length != 0) || "Поле 'Категория' не может быть пустым",
            ],
            /*cat_items: [
              {
                sel_id: 1,
                name: "Категория 1",
              },
              {
                sel_id: 2,
                name: "Категория 2",
              },
              {
                sel_id: 3,
                name: "Категория 2",
              },
            ],*/
            cat_items: this.categories,
            defaultСatSelected: {
                sel_id: 0,
            },
        }
    },
    methods: {
        linkOpen(url) {
            window.open(url, '_blank');
        },
        // Captcha
        initCaptcha() {
            window.smartCaptcha.render('captcha-container', {
                sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
                callback: this.onCaptchaSuccess,
            });
        },
        onCaptchaSuccess(token) {
            this.captchaPassed = true;
            this.form.captchaToken = token;
        },
        // Captcha end
        send_form() {
            /*const form = {
              name: this.name,
              company: this.company,
              city: this.city,
              tel: this.tel.split(' - ').join(''),
              mail: this.mail,
              message: this.message
            }*/

            if (!this.$refs.form_inner.validate()) return false;
            // if (!this.captchaPassed) {
            //     this.valid = false;
            //     return false;
            // } else {
            //     this.valid = true;
            // }

            let url = "/ajax/send_bid_form.php";
            let params = new URLSearchParams();
            let category = this.cat_items.find(cat_items => cat_items.sel_id === this.defaultСatSelected.sel_id).name;
            console.log(category);
            params.set("name", this.name);
            params.set("company", this.company);
            params.set("city", this.city);
            params.set("tel", this.tel);
            params.set("mail", this.mail);
            params.set("message", this.message);
            params.set("category", category);
            params.set("ajaxPost", "Y");
            params.set("url", document.location.href);

            var result = fetch(url, {method: "POST", body: params})
                .then(function (responce) {
                    return responce.json();
                })
                .then((data) => {
                    console.log(JSON.stringify(data));
                });
            console.log(result);
            this.$refs.form_inner.reset();
            this.$refs.modal_contents_successfully.modal_open() //- вывод сообщения
        }
    },
    created() {
        setTimeout(() => {
            this.initCaptcha();
        }, 500)
    },
    watch: {
        captchaPassed() {
            // this.sendForm();
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
        },
    }
}
</script>
<style lang="scss">
.green_messs {
  color: #419841;
}

.v-menu__content.wrapper_cat_items {
  margin-top: 61px;
  border-radius: 10px;
  border: 1px solid #DEDEDE;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.08);

  & .primary--text {
    color: #FF4237 !important;
    caret-color: #FFF8F8 !important;
  }
}

.bid_form {

  .smart-captcha.error-captcha:before {
    background: transparent;
    color: #FA4237;
    transform: translateY(-8px);
  }

  & .cat_items {
    padding-top: 0;
    margin-top: 0;
    width: 228px;
    border: 1px solid #E2E2E2;
    border-radius: 10px;

    &.v-input--is-label-active {
      & .v-label--active {
        display: none !important;
      }
    }

    &.v-text-field--is-booted:not(.v-select--is-menu-active) {
      & .v-label--active {
        display: none;
      }
    }

    & .v-label {
      top: 19px;
      left: 16px !important;
    }


    & .v-select__selections {
      border-radius: 10px;
      padding: 13px 15px !important;
      margin: 0 !important;
      font-weight: 400;
      font-size: 16px;
      line-height: 100%;
      color: #282828;
      resize: none;
    }

    & .v-input__append-inner {
      margin-top: 16px;
      margin-right: 11px;
    }
  }

  & .v-input__slot {
    margin: 0 !important;

    &::before {
      display: none !important;
    }

    &::after {
      display: none !important;
    }
  }

  .v-text-field__details {
    position: absolute;
    display: flex;
    transform: translate(-1px, 30px);
  }

  & .v-text-field__slot {
    input[type=text], textarea {
      padding: 0 !important;
      width: 100% !important;
      height: 100% !important;
    }

    .v-label {
      top: 0 !important;
      color: #656565 !important;
    }
  }

}

</style>
<style scoped lang="scss">
.form {
  width: 100%;

  h2.formNew_h2 {
    font-family: "MuseoSansCyrl-500";
    font-weight: 400;
    font-size: 52px;
    leading-trim: NONE;
    line-height: 68px;
    letter-spacing: -1.04px;
    vertical-align: middle;

    @media (max-width: 1000px) {
      font-size: 46px;
      line-height: 56px;
    }

    @media (max-width: 650px) {
      font-size: 38px;
      line-height: 44px;
    }

    @media (max-width: 500px) {
      font-size: 30px;
      line-height: 36px;
    }

  }

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 40px;
  }

  &__title {
    font-weight: 600;
    font-size: 28px;
    line-height: 100%;
    color: #282828;

    @media(max-width: 450px) {
      font-size: 22px;
    }
  }

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    width: 100%;

    @media (max-width: 960px) {
      grid-template-columns: 1fr;
    }

    & h3 {
      font-family: 'MuseoSansCyrl-500';
      font-weight: 400;
      font-size: 52px;
      line-height: 68px;
      letter-spacing: -1.04px;
      color: #212424;
    }
  }

  &__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 20px;
    background: #F5F5F7;
    border-radius: 40px;
    padding: 40px;

    @media (max-width: 425px) {
      padding: 20px;
    }

    .smart-captcha {
      min-width: 250px;
    }
  }

  &__box {
    width: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: end;
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }

    @media (max-width: 768px) {
      flex-wrap: wrap;
    }
  }

  &__input {
    width: auto;
    border-radius: 10px;
    border: 1px solid #E2E2E2 !important;
    background: #ffffff;
    padding: 32px !important;
    margin: 0 !important;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #2D2B32 !important;
    resize: none;
  }

  .error--text {
    border: 1px solid #FA4237;
    color: #FA4237;
  }

  &__policy {
    max-width: 379px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    color: #656565;
  }

  &__link {
    display: inline-block;
    color: #F55640;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__button {
    transition: all .3s ease;

    &:disabled {
      background: #E2E2E2;
      color: #656565;

      &:hover {
        background: #E2E2E2;
        color: #656565;
      }
    }

  }
}

</style>